const { createApp, ref, component, watch, onMounted, reactive, onBeforeMount, Transition } = Vue;
const familyPlanState = reactive({
  addOnDiscountType: null,
  productDiscountType: null,
  memberPlans: [],
  config: {},
  setCount: 0,
  shippingType: '',
  isPlanInCart: false,
  cart: {
    shortSummary: {
      product_title: 'Diffusers',
      addon_title: 'Oils',
      productTotalPrice: 0,
      productTotalDiscountPrice: 0,
      addonTotalPrice: 0,
      addonTotalDiscountPrice: 0
    },
    line_items: []
  },
  error: null,
  savings: {
    memberSavings: 0,
    oilSavings: 0,
  },
});

const validationErr = reactive({ error: null });

const familySubscriptionApp = createApp({
  name: "familySubscriptionApp",
  setup() {
    // Initializing familyPlanState with data from familyPlanDataObj
    familyPlanState.config = familyPlanDataObj;
    familyPlanState.addOnDiscountType = familyPlanDataObj.addon_discount_type;
    familyPlanState.productDiscountType = familyPlanDataObj.product_discount_type;
    familyPlanState.addonDiscountArr = familyPlanDataObj.addon_discount_ratio_breakup;
    familyPlanState.productDiscountArr = familyPlanDataObj.product_discount_ratio_breakup;
    familyPlanState.setCount = familyPlanState.config.min_plan;
    familyPlanState.memberPlans = new Array(familyPlanState.config.min_plan).fill({
      main_product: null,
      addon_product: null,
      type:null
    });

    familyPlanState.cart.shortSummary.product_title = familyPlanDataObj.parent_product.title;

    // Pre-populating from URL if available
    onMounted(() => {
      loadSets();

      document.getElementById('familySubscriptionApp').style.visibility = "visible";
      calculateAnnualSavings();

      document.addEventListener("rebuy:cart.ready", function (event) {
        updateCartState();
      })

      document.addEventListener("rebuy:cart.change", function (event) {
        setTimeout(() => {
          updateCartState();
        }, 3000);
      })

    });

    function loadSets() {
      const storedData = JSON.parse(localStorage.getItem('homePlanData')) || {};
      const productIds = storedData.products || [];
      const addonIds = storedData.addons || [];
      const productTypes = storedData.types || [];
      const shippingType = storedData.shippingType || 'one';
    
      let loadedSets = productIds.length;
    
      // Ensure the minimum of 2 sets and maximum of 5 sets
      if (loadedSets < familyPlanState.config.min_plan) {
        while (loadedSets < familyPlanState.config.min_plan) {
          productIds.push(null);
          addonIds.push(null);
          productTypes.push(null);
          loadedSets++;
        }
      } else if (loadedSets > familyPlanState.config.max_plan) {
        productIds.length = familyPlanState.config.max_plan;
        addonIds.length = familyPlanState.config.max_plan;
        productTypes.length = familyPlanState.config.max_plan;
      }
    
      familyPlanState.memberPlans = productIds.map((productId, index) => {
        const productType = productTypes[index];
        const mainProduct = productType === 'A'
          ? familyPlanState.config.parent_product.variants.find(v => v?.id == productId)
          : familyPlanState.config.parent_product_b.variants.find(v => v?.id == productId);
    
        const addonProduct = productType === 'A'
          ? familyPlanState.config.products.find(a => a?.id == addonIds[index])
          : familyPlanState.config.products_b.find(a => a?.id == addonIds[index]);
    
        return {
          main_product: mainProduct || null,
          addon_product: addonProduct || null,
          type: productType || null
        };
      });
    
      familyPlanState.setCount = familyPlanState.memberPlans.length;
      familyPlanState.shippingType = shippingType;
    }

    // function loadSetsFromUrlParams() {
    //   const params = new URLSearchParams(window.location.search);
    //   const productIds = params.getAll("product[]");
    //   const addonIds = params.getAll("addon[]");
    //   const productTypes = params.getAll("type[]");
    //   const shippingType = params.get('shippingType');
    
    //   let loadedSets = productIds.length;

    //   // Ensure the minimum of 2 sets and maximum of 5 sets
    //   if (loadedSets < familyPlanState.config.min_plan) {
    //     while (loadedSets < familyPlanState.config.min_plan) {
    //       // Add null sets to meet the minimum requirement
    //       productIds.push(null);
    //       addonIds.push(null);
    //       productTypes.push(null); // Default type for the additional sets
    //       loadedSets++;
    //     }
    //   } else if (loadedSets > familyPlanState.config.max_plan) {
    //     // Trim the excess sets if it exceeds the maximum limit
    //     productIds.length = familyPlanState.config.max_plan;
    //     addonIds.length = familyPlanState.config.max_plan;
    //     productTypes.length = familyPlanState.config.max_plan;
    //   }

    //   // Populate member plans based on the product and addon IDs
    //   familyPlanState.memberPlans = productIds.map((productId, index) => {
    //     const productType = productTypes[index];
    //     const mainProduct = productType === 'A'
    //       ? familyPlanState.config.parent_product.variants.find(v => v?.id == productId)
    //       : familyPlanState.config.parent_product_b.variants.find(v => v?.id == productId);

    //     const addonProduct = productType === 'A'
    //       ? familyPlanState.config.products.find(a => a?.id == addonIds[index])
    //       : familyPlanState.config.products_b.find(a => a?.id == addonIds[index]);

    //     return {
    //       main_product: mainProduct || null,
    //       addon_product: addonProduct || null,
    //       type: productType || null
    //     };
    //   });

    //   // Set the count of member plans to the length of the loaded sets
    //   familyPlanState.setCount = familyPlanState.memberPlans.length;

    //   // commented since the label is coming dynamically from metaobjects
    //   //loading shipping type state
    //   if (shippingType && shippingType === 'multiple') {
    //     familyPlanState.shippingType = 'multiple';
    //   } else {
    //     familyPlanState.shippingType = 'one';
    //   }

    // }

    // Watching for changes in memberPlans and updating URL params
    watch(() => familyPlanState.memberPlans, (newValue) => {
      //console.log("🚀 ~ watch ~ newValue: cart line items", newValue);
      familyPlanState.cart.line_items = newValue.map((c, index) => {
        if (c.main_product == null && c.addon_product == null) {
          return { product: {}, addon: {},type:null };
        }

        let mainProduct = c.main_product;
        let addOn = c.addon_product;
        let mainProductDiscountPrice = null;
        let addOnProductDiscountPrice = null;
        if(c.type === 'A'){
          mainProductDiscountPrice = calculateDiscount(mainProduct.price, familyPlanState.config.product_discount_ratio_breakup[index], familyPlanState.config.product_discount_type);
          addOnProductDiscountPrice = calculateDiscount(addOn.price, familyPlanState.config.addon_discount_ratio_breakup[index], familyPlanState.config.addon_discount_type);
        }else if(c.type === 'B'){
          mainProductDiscountPrice = calculateDiscount(mainProduct.price, familyPlanState.config.product_discount_ratio_breakup_b[index], familyPlanState.config.product_discount_type);
          addOnProductDiscountPrice = calculateDiscount(addOn.price, familyPlanState.config.addon_discount_ratio_breakup_b[index], familyPlanState.config.addon_discount_type);
        }
        return {
          product: {
            id: mainProduct.id,
            main_product_title: mainProduct.main_title,
            variant_title: mainProduct.title,
            price: mainProduct.price,
            discount: familyPlanState.config.product_discount_ratio_breakup[index],
            type:c.type,// set type
            discount_type: familyPlanState.config.product_discount_type,
            discounted_price: mainProductDiscountPrice
          },
          addon: {
            id: addOn.id,
            title: `${addOn.main_product.title} - ${addOn.title}`,
            price: addOn.price,
            discount: familyPlanState.config.addon_discount_ratio_breakup[index],
            type:c.type, // set type
            discount_type: familyPlanState.config.addon_discount_type,
            discounted_price: addOnProductDiscountPrice,
            inspired_by: addOn?.inspired_by || null,
            scent_notes: addOn?.scent_notes || null,
            selling_plan_id: addOn.selling_plan_allocations[0]?.selling_plan_id || ''
          }
        };
      });

     // updateUrlParams(familyPlanState.cart.line_items);
     updateLocalStorage(familyPlanState.cart.line_items);
      prepareCartShortSummary();
      calculateAnnualSavings();
    }, { deep: true });

    watch(() => familyPlanState.shippingType, (newValue) => {
     // updateUrlParams(familyPlanState.cart.line_items);
      updateLocalStorage(familyPlanState.cart.line_items);
    });

    // Function to update URL with product and addon ids
    function updateUrlParams(lineItems) {
      const params = new URLSearchParams();
    
      lineItems.forEach(item => {
        if (item.product?.id && item.addon?.id) {
          params.append("product[]", item.product.id);
          params.append("addon[]", item.addon.id);
          params.append("type[]", item.product.type);    
        }
      });
    
      // Add shipping type to the params
      if (familyPlanState.shippingType && lineItems.length && lineItems[0].product?.id) {
        params.append("shippingType", familyPlanState.shippingType);
      }
    
      history.replaceState(null, "", "?" + params.toString());
    }

    // Function to update localStorage with product and addon ids
    function updateLocalStorage(lineItems) {
      const storedData = {
        products: [],
        addons: [],
        types: [],
        shippingType: familyPlanState.shippingType || 'one'
      };

      lineItems.forEach(item => {
        if (item.product?.id && item.addon?.id) {
          storedData.products.push(item.product.id);
          storedData.addons.push(item.addon.id);
          storedData.types.push(item.product.type);
        }
      });

      localStorage.setItem('homePlanData', JSON.stringify(storedData));
    }

    
    function updateCartState() {
      const { items } = Rebuy.Cart.cart
      const fpItems = items.filter(item => {
        return item.properties["_fp_id"]
      })
      if (fpItems.length >= 3) {
        familyPlanState.isPlanInCart = true
      } else {
        familyPlanState.isPlanInCart = false
      }
    }


    // Other functions
    function handleAddNewSet() {
      familyPlanState.memberPlans.push({
        main_product: null,
        addon_product: null
      });
      familyPlanState.setCount = familyPlanState.setCount + 1;
    }

    function handleItemDelete(e) {
      familyPlanState.memberPlans[e.value] = {
        main_product: null,
        addon_product: null
      };
    }

    function prepareCartShortSummary() {
      let productTotalPrice = 0;
      let productTotalDiscountPrice = 0;
      let addonTotalPrice = 0;
      let addonTotalDiscountPrice = 0;

      if (familyPlanState.cart.line_items.length > 0) {
        for (const item of familyPlanState.cart.line_items) {
          if (Object.keys(item.product).length > 0 && Object.keys(item.addon).length > 0) {
            productTotalPrice += item.product.price;
            productTotalDiscountPrice += item.product?.discounted_price || 0;
            addonTotalPrice += item.addon.price;
            addonTotalDiscountPrice += item.addon?.discounted_price || 0;
          }
        }

        familyPlanState.cart.shortSummary = {
          product_title: familyPlanState.config.parent_product.title,
          addon_title: 'Oils',
          productTotalPrice: productTotalPrice,
          productTotalDiscountPrice: productTotalDiscountPrice,
          addonTotalPrice: addonTotalPrice,
          addonTotalDiscountPrice: addonTotalDiscountPrice,
          totalSavings: (addonTotalPrice) - (addonTotalDiscountPrice)
        };
      }
    }

    function calculateAnnualSavings() {
      const selecteQty = familyPlanState.memberPlans.length;
      const discountValue = Number(familyPlanState.config.addon_discount_ratio_breakup[selecteQty]);
      const convertedAddonDiscArr = familyPlanState.config.addon_discount_ratio_breakup.map(parseFloat);
      const totalOilSavings = convertedAddonDiscArr.reduce((acc, currentValue) => acc + currentValue, 0) * 12;

      if (familyPlanState.config.addon_discount_type === 'PERCENTAGE') {
        familyPlanState.savings.memberSavings = discountValue + "%";
        familyPlanState.savings.oilSavings = Math.max(...convertedAddonDiscArr) + "%";
      } else {
        familyPlanState.savings.memberSavings = formatMoney((discountValue * 12) * 100);
        familyPlanState.savings.oilSavings = formatMoney((totalOilSavings) * 100);
      }
    }

    function calculateSavingsForecast() {
      const mainProduct = familyPlanState.config.parent_product.variants[0];
      const addOnProduct = familyPlanState.config.products[0];
      if (mainProduct && addOnProduct) {
        const selecteQty = familyPlanState.memberPlans.length;
        const mainProductSavings = fetchDiscountValue(mainProduct.price, familyPlanState.config.product_discount_ratio_breakup[selecteQty], familyPlanState.config.product_discount_type);
        const addOnProductSavings = fetchDiscountValue(addOnProduct.price, familyPlanState.config.addon_discount_ratio_breakup[selecteQty], familyPlanState.config.addon_discount_type);
        return formatMoney(mainProductSavings + addOnProductSavings);
      }
      return formatMoney(0);
    }

    return {
      familyPlanState,
      handleItemDelete,
      prepareCartShortSummary,
      handleAddNewSet,
      calculateAnnualSavings,
      calculateSavingsForecast
    };
  },
  delimiters: ["${", "}"],
});

// counter
familySubscriptionApp.component("counter-block", {
  template: "#counterBlock",
  emits: ["on-qty-change"],
  props: ["min_qty", "max_qty", "line_item_qty"],
  setup(props, ctx) {

    function handleShippingTypeChange(type) {
      //console.log('handleShippingTypeChange', type)
      familyPlanState.shippingType = type
      if (type == 'one') {
        familyPlanState.config.line_item_label = "DIFFUSER"
      } else {
        familyPlanState.config.line_item_label = "MEMBER"
      }
    }
    
    function handleQtySelect(action) {
      if (action === '+') {
        familyPlanState.memberPlans.push({
          main_product: null,
          addon_product: null
        });
        familyPlanState.setCount = familyPlanState.setCount + 1;
      }
      if (action === '-') {
        familyPlanState.setCount = familyPlanState.setCount - 1;
        let idx = familyPlanState.setCount - 1;
        familyPlanState.memberPlans.splice(idx, 1);
      }
    }

    return {
      handleQtySelect,
      handleShippingTypeChange,
      pluralize,
      sectionSettings,
      familyPlanState
    }
  },
  delimiters: ["${", "}"],
});

// line item
familySubscriptionApp.component("line-item", {
  template: "#lineItem",
  emits: ["on-line-item-delete"],
  props: ["item", "item_index", "selected_plan_qty"],
  setup(props, ctx) {
    const selectedProduct = ref(null);
    const isProductAPopUpOpen = ref(false);
    const isAddonAPopUpOpen = ref(false);
    const isProductBPopUpOpen = ref(false);
    const isAddonBPopUpOpen = ref(false);
    const isNewMember = ref(true);
    const productType = ref('');

    onMounted(() => {
     // loadDataFromUrlParams();
      loadDataFromLocalStorage();
    });

    function loadDataFromLocalStorage() {
      const storedData = JSON.parse(localStorage.getItem('homePlanData')) || {};
      const productIds = storedData.products || [];
      const addonIds = storedData.addons || [];
      const types = storedData.types || [];
    
      const currentProductId = productIds[props.item_index] || null;
      const currentAddonId = addonIds[props.item_index] || null;
    
      if (types[props.item_index] === 'scent') {
        handleProductSelect('scent', currentProductId, currentAddonId);
      } else if (types[props.item_index] === 'car') {
        handleProductSelect('car', currentProductId, currentAddonId);
      }
    }

    function loadDataFromUrlParams() {
      // Initialize the member plan for the current item_index on mount
      const urlParams = new URLSearchParams(window.location.search);
      const types = urlParams.getAll('type[]');
      const productIds = urlParams.getAll("product[]");
      const addonIds = urlParams.getAll("addon[]");


      const currentProductId = productIds[props.item_index] || null;
      const currentAddonId = addonIds[props.item_index] || null;

      // Check the product type based on the URL parameters
      if (types[props.item_index] === 'scent') {
        handleProductSelect('scent', currentProductId, currentAddonId);
      } else if (types[props.item_index] === 'car') {
        handleProductSelect('car', currentProductId, currentAddonId);
      }
    }
    

    function toggleProductPopup() {
      if(diffuserTypeIds.indexOf(props.item.main_product.main_id) === 0){
        isProductAPopUpOpen.value = true;
      }
      if(diffuserTypeIds.indexOf(props.item.main_product.main_id) === 1){
        isProductBPopUpOpen.value = true;
      }
    }

    function handleProductPopupClose() {
      isProductAPopUpOpen.value = false;
    }

    function handleAddonPopupClose() {
      isAddonAPopUpOpen.value = false;
    }

    function toggleOilPopup() {
      if(diffuserTypeIds.indexOf(props.item.main_product.main_id) === 0){
        isAddonAPopUpOpen.value = true;
      }
      if(diffuserTypeIds.indexOf(props.item.main_product.main_id) === 1){
        isAddonBPopUpOpen.value = true;
      }
    }

    function handleOilPopupClose() {
      isAddonAPopUpOpen.value = false;
    }

    function removePlan(index) {
      if (familyPlanState.setCount > familyPlanState.config.min_plan) {
        familyPlanState.memberPlans.splice(index, 1);
        familyPlanState.setCount = familyPlanState.setCount - 1;
      }
    }

    function isProductHasSavings(type = ''){
      if(type === 'MAIN_PRODUCT'){
        const discountArr = props.item.type === 'A' ? familyPlanState.config.product_discount_ratio_breakup : familyPlanState.config.product_discount_ratio_breakup_b;
        const discountValue = Number(discountArr[props.item_index]);
        return discountValue;
      }else if(type === 'ADDON_PRODUCT'){
        const discountArr = props.item.type === 'A' ? familyPlanState.config.addon_discount_ratio_breakup : familyPlanState.config.addon_discount_ratio_breakup_b;
        const discountValue = Number(discountArr[props.item_index]);
        return discountValue;
      }
    }

    function renderSavingsTag(type = ''){
      if(type === 'MAIN_PRODUCT'){
        const discountArr = props.item.type === 'A' ? familyPlanState.config.product_discount_ratio_breakup : familyPlanState.config.product_discount_ratio_breakup_b;
        const discountValue = Number(discountArr[props.item_index]);
        const discountText = familyPlanState.config.product_discount_type === 'PERCENTAGE' ? `${discountValue.toFixed()}%` : `$${discountValue}`;
        return `${discountText} OFF`;
      }else if(type === 'ADDON_PRODUCT'){
        const discountArr = props.item.type === 'A' ? familyPlanState.config.addon_discount_ratio_breakup : familyPlanState.config.addon_discount_ratio_breakup_b;
        const discountValue = Number(discountArr[props.item_index]);
        const discountText = familyPlanState.config.addon_discount_type === 'PERCENTAGE' ? `${discountValue.toFixed()}%` : `$${discountValue}`;
        return `${discountText} OFF`;
      }
    }

    function handleProductConfirm(event) {
      isProductAPopUpOpen.value = false;
      const updatedMemberPlanArr = [...familyPlanState.memberPlans];
      updatedMemberPlanArr[props.item_index] = {
        main_product: event.main_product,
        addon_product: updatedMemberPlanArr[props.item_index].addon_product,
        type:'A'
      };
      familyPlanState.memberPlans = updatedMemberPlanArr;
    }

    function handleAddonConfirm(event) {
      isAddonAPopUpOpen.value = false;
      const updatedMemberPlanArr = [...familyPlanState.memberPlans];
      updatedMemberPlanArr[props.item_index] = {
        addon_product: event.addon_product,
        main_product: updatedMemberPlanArr[props.item_index].main_product,
        type:'A'
      };
      familyPlanState.memberPlans = updatedMemberPlanArr;
    }

    function calculateTotalSaving(type) {
      if (familyPlanState.cart.line_items[props.item_index]) {
        if (type === 'monthly') {
          let addonDisountPrice = familyPlanState.cart.line_items[props.item_index].addon.discounted_price;
          return addonDisountPrice;
        } else {
          let prodPrice = familyPlanState.cart.line_items[props.item_index].product.price;
          let prodDiscountPrice = familyPlanState.cart.line_items[props.item_index].product.discounted_price || 0;
          let addonPrice = familyPlanState.cart.line_items[props.item_index].addon.price;
          let addonDisountPrice = familyPlanState.cart.line_items[props.item_index].addon.discounted_price;
          return (prodPrice - prodDiscountPrice) + (addonPrice - addonDisountPrice);
        }
      }
    }

    function isProductAvailable(product_index, type){
      if(type === 'scent' && familyPlanState.config.parent_product.available){
        return familyPlanState.config.parent_product.available
      } else {
        return familyPlanState.config.parent_product_b.available
      }
    }



    function handleProductSelect(type, productId, addonId){
      //console.log(type)
      productType.value = type;
      isNewMember.value = false;
      let selectedProduct = {
        main_product: {},
        addon_product:{},
        type: ""
      };
      if(type === 'A'){
        selectedProduct.main_product = getAvailableProduct('A','main', productId);
        selectedProduct.addon_product = getAvailableProduct('A','addon', addonId);
        selectedProduct.type = "A";
      } else if (type === 'B') {
        selectedProduct.main_product = getAvailableProduct('B','main', productId);
        selectedProduct.addon_product = getAvailableProduct('B','addon', addonId);
        selectedProduct.type = "B";
      }
      //console.log(selectedProduct)
      const updatedMemberPlanArr = [...familyPlanState.memberPlans];
      updatedMemberPlanArr[props.item_index] = selectedProduct;
      familyPlanState.memberPlans = updatedMemberPlanArr;
    }

    function getAvailableProduct(pType, product, id = null) {
      if (pType === 'A') {
        if (product === 'main') {
          // If an id is provided, find by id; otherwise, return the first available product
          return id
            ? familyPlanState.config.parent_product.variants.find(v => v?.id == id)
            : familyPlanState.config.parent_product.variants.find(v => v.available);
        } else {
          return id
            ? familyPlanState.config.products.find(v => v?.id == id)
            : familyPlanState.config.products.find(v => v.available);
        }
      } else if (pType === 'B') {
        if (product === 'main') {
          return id
            ? familyPlanState.config.parent_product_b.variants.find(v => v?.id == id)
            : familyPlanState.config.parent_product_b.variants.find(v => v.available);
        } else {
          return id
            ? familyPlanState.config.products_b.find(v => v?.id == id)
            : familyPlanState.config.products_b.find(v => v.available);
        }
      }
      return null; // Return null if no match is found
    }
    

    function handleProductBPopupClose(){
      isProductBPopUpOpen.value = false;
    }

    function handleProductBConfirm(event){
      // //console.log("🚀 ~ handleProductConfirm ~ event:", event)
      isProductBPopUpOpen.value = false;
      const updatedMemberPlanArr = [...familyPlanState.memberPlans];
      updatedMemberPlanArr[props.item_index] = {
        main_product: event.main_product,
        addon_product: updatedMemberPlanArr[props.item_index].addon_product,
        type:'B'
      };
      familyPlanState.memberPlans = updatedMemberPlanArr;
    }

    function handleAddonBPopupClose(){
      isAddonBPopUpOpen.value = false;
    }

    function handleAddonBConfirm(event){
      isAddonBPopUpOpen.value = false;
      const updatedMemberPlanArr = [...familyPlanState.memberPlans];
      updatedMemberPlanArr[props.item_index] = {
        addon_product: event.addon_product,
        main_product: updatedMemberPlanArr[props.item_index].main_product,
        type:'B'
      };
      familyPlanState.memberPlans = updatedMemberPlanArr;
    }

    return {
      familyPlanState,
      validationErr,
      sectionSettings,
      selectedProduct,
      isProductAPopUpOpen,
      isProductBPopUpOpen,
      isAddonAPopUpOpen,
      isAddonBPopUpOpen,
      isNewMember,
      productType,
      removePlan,
      imgUrl,
      renderSavingsTag,
      isProductHasSavings,
      formatMoney,
      toggleProductPopup,
      handleProductPopupClose,
      handleAddonPopupClose,
      handleProductConfirm,
      handleAddonConfirm,
      toggleOilPopup,
      handleOilPopupClose,
      calculateTotalSaving,
      isProductAvailable,
      handleProductSelect,
      handleProductBPopupClose,
      handleProductBConfirm,
      handleAddonBPopupClose,
      handleAddonBConfirm
    }
  },
  delimiters: ["${", "}"],
})

// floating cart
familySubscriptionApp.component("floating-cart", {
  template: "#floatingCart",
  props: ["cart"],
  setup(props, ctx) {
    const cartItemsObj = ref(props.cart);
    const isLoading = ref(false);
    const cartTotal = ref(0);
    const cartSavings = ref(0);
    const seeMore = ref(false);
    const minQty = ref(familyPlanState.setCount);
    const subsPrice = ref(0);
    const isValid = ref(false);
    const errMsg = ref(null);
    const showPlanBenifits = ref(true);

    watch(() => props.cart.line_items, (newValue) => {
      cartItemsObj.value.line_items = newValue;
      cartTotal.value = cartItemsObj.value.shortSummary.productTotalDiscountPrice + cartItemsObj.value.shortSummary.addonTotalDiscountPrice;
      cartSavings.value = (cartItemsObj.value.shortSummary.productTotalPrice + cartItemsObj.value.shortSummary.addonTotalPrice) - cartTotal.value;
      calculateSubsPrice();
    });

    watch([() => familyPlanState.memberPlans, () => familyPlanState.cart], () => {
      validateCart(false)
    }, { deep: true });

    function toggleSeeMore() {
      seeMore.value = !seeMore.value;
    }

    function changeSeeMoreText() {
      return seeMore.value ? 'See Less' : 'See More';
    }

    function getbundleProducts(bundleProp) {
      const {items} = Rebuy.Cart.cart
      let bundleProducts = []
      items.map(item => {
        if (item.properties[bundleProp]) {
          bundleProducts.push(item)
        }
      })
      return bundleProducts
    }

    async function updateLineItemWithQty(bundleProducts, qty) {
      qty = parseInt(qty)
      const newObj = {};
      bundleProducts.forEach(item => {
        newObj[item.key.toString()] = qty
      });
      try {
       await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: newObj
        });
        
      } catch (error) {
        console.log(error);
      }
    }


    async function handleAddToCart() {
      validateCart();
      if (isValid.value) {
        if(familyPlanState.isPlanInCart) {
          const bundleProducts = getbundleProducts("_fp_id");
          if (bundleProducts) {
            await updateLineItemWithQty(bundleProducts, 0)
          }
        }

        let productArr = cartItemsObj.value.line_items;
        //console.log('productArr', productArr, cartItemsObj)
        if (productArr.length) {
          isLoading.value = true;
          if (familyPlanState.shippingType == 'one') {
            const fpId = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

            // Map the productArr to planArr, including fq_product
            const planArr = productArr.map(({ product, addon }) => ({
              product_variant_id: product.id,
              addon_variant_id: addon.id,
              addon_selling_plan_id: addon.selling_plan_id,
              fq_product: {
                product_title: `${product.main_product_title} - ${product.variant_title}`,
                addon_title: addon.title
              }
            }));
            
            // Collect all products and addons into one array (_fq_products)
            const fqProducts = planArr.map(item => ({
              product_title: item.fq_product.product_title,
              addon_title: item.fq_product.addon_title
            }));
            
            const items = planArr.reduce((acc, item, index) => {
              // Properties with _fq_products including all items with same _fp_id
              const properties = {
                _fp_member: index + 1,
                _fp_id: fpId,
                _fp_slashed_out_price: cartTotal.value + parseFloat(cartItemsObj.value.shortSummary.totalSavings),
                _fp_sale_price: cartTotal.value,
                _fp_off_value: cartItemsObj.value.shortSummary.totalSavings,
                _fp_img: 'https://cdn.shopify.com/s/files/1/0517/2402/6050/files/family-plan-hero-mob.jpg?v=1718960645',
                _fp_url: "/pages/home-plan",
                _fq_products: fqProducts, // Pass all products and addons for each item
                _fp_identifier: "true",
              };
            
              // Add product variant
              acc.push({
                id: item.product_variant_id,
                quantity: 1,
                properties
              });
            
              // Add addon variant with selling_plan_id
              acc.push({
                id: item.addon_variant_id,
                quantity: 1,
                selling_plan: item.addon_selling_plan_id,
                properties: {...properties, _fp_oil: "true"}
              });
            
              return acc;
            }, []);

            //console.log('items', items)
          if (Rebuy && familyPlanState.config.redirect_to_checkout) Rebuy.SmartCart.skip_open = true;
          try {
            const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ items }),
            })
            const data = await response.json();
            isLoading.value = false;
            if (data && familyPlanState.config.redirect_to_checkout) {
              let str = window.location.href.includes("/es/") ? "?locale=es" : "";
              str = "/checkout" + str;
              window.location.href = str;
            }
            return
          } catch (error) {
            isLoading.value = false;
            console.error(error);
          }
          } else {
            const planArr = productArr.map(({ product, addon }) => ({ product_variant_id: product.id, addon_variant_id: addon.id }));
            const formatedPlanArr = {
              meta_object_id: familyPlanState.config.meta_object_id,
              plans: planArr,
              landing_url: utilFetchCookieValue('landing_url'),
              cookies_data: document.cookie.replace(/"/g, '\\"'),
              local_storage: '',
            }
            if (familyPlanState.config.enable_safe_ship) {
              formatedPlanArr.safe_ship = {
                variant_id: familyPlanState.config.safe_ship_variant.id
              }
            }
            var reqHeaders = new Headers();
            reqHeaders.append("Content-Type", "application/json");
            ////console.log("🚀 ~ handleAddToCart ~ sectionSettings.family_plan_endpoint:", sectionSettings.family_plan_endpoint)
            var requestOptions = {
              method: 'POST',
              headers: reqHeaders,
              body: JSON.stringify(formatedPlanArr)
            };
            fetch(sectionSettings.family_plan_endpoint, requestOptions)
              .then(response => response.json())
              .then(result => {
                if (result.status === 200 && result.success) {
                  const url = result.checkout_url;
                  window.location.href = url;
                }
              })
              .catch(error => {
                isLoading.value = false;
              });
            
          }

        }
      }
    }

    function validateCart(printErr = true) {
      let validFlg = true;
      for (let i = 0; i < familyPlanState.memberPlans.length; i++) {
        if (!familyPlanState.memberPlans[i].main_product && !familyPlanState.memberPlans[i].addon_product) {
          validFlg = false;
          if (printErr) {
            validationErr.error = { line_index: i, msg: `Please complete the plan for ${familyPlanState.config.line_item_label} ${i + 1}` };
          }
          break;
        }
      }
      isValid.value = validFlg;
      if (isValid.value || !printErr) {
        validationErr.error = null;
      }
    }

    function calculateSubsPrice() {
      if (familyPlanState.config.addon_discount_frequency_type = "RECURRING") {
        subsPrice.value = cartItemsObj.value.shortSummary.addonTotalDiscountPrice;
      }
      else {
        subsPrice.value = cartItemsObj.value.shortSummary.addonTotalPrice;
      }
    }

    return {
      isLoading,
      cartItemsObj,
      cartTotal,
      cartSavings,
      seeMore,
      minQty,
      subsPrice,
      familyPlanState,
      validationErr,
      errMsg,
      isValid,
      showPlanBenifits,
      handleAddToCart,
      formatMoney,
      toggleSeeMore,
      calculateSubsPrice,
      changeSeeMoreText
    }
  },
  delimiters: ["${", "}"],
})

// select product variant popup
familySubscriptionApp.component("select-variant-popup", {
  template: "#selectVariantPopup",
  props: ["is_open", "index"],
  emits: ["on_product_confirm", "on_close"],
  setup(props, ctx) {
    const selectedVariant = ref(null);
    const selectedTypeOption = ref(null);
    const typeOptions = ref(Array.from(new Set(familyPlanState.config.parent_product.variants.map(p => p.title.split("/")[0].trim().toUpperCase()))));
    const typeOptionVariants = ref(typeOptions.value.reduce((acc, p) => {
      acc[p] = familyPlanState.config.parent_product.variants.filter(v => p === v.title.split("/")[0].trim().toUpperCase()).map(v => ({
        name: v.title.trim().toUpperCase(),
        variant_id: v.id,
        available: v.available,
        custom_swatch: v.custom_swatch,
        hide_variant: v.hide_variant,
      }));
      return acc;
    }, {}));

    onMounted(() => {
      selectedVariant.value = familyPlanState.config.parent_product.variants.find(v => v.available);
      const typeOption = selectedVariant.value.title.split("/")[0].trim().toUpperCase();
      if (typeOptions.value.includes(typeOption)) selectedTypeOption.value = typeOption;
      // if((props.index-1) < familyPlanState.config.min_plan){
      //   handleConfirm();
      // }
    });

    watch(() => props.is_open, () => {
      document.documentElement.style.overflow = "unset";
      if (props.is_open) {
        document.documentElement.style.overflow = "hidden";
      }
    });

    function handleClose() {
      ctx.emit("on_close", null)
    }

    function handleOptionTypeChange(type) {
      selectedTypeOption.value = type;
      let firstAvailableVariant = typeOptionVariants.value[selectedTypeOption.value].find(v => v.available);
      selectedVariant.value = familyPlanState.config.parent_product.variants.find(v => v.id === firstAvailableVariant.variant_id);
    }

    function handleRadioCheck(type) {
      return type === selectedTypeOption.value ? true : false;
    }

    function handleAddonSelect(variant) {
      selectedAddon.value = variant;
      isDropdownOpen.value = false;
    }

    function handleConfirm() {
      if (selectedVariant.value) {
        ctx.emit("on_product_confirm", {
          main_product: selectedVariant.value
        });
      }
    }

    function handleVariantChange(e){
      selectedVariant.value = e;
    }

    return {
      selectedVariant,
      sectionSettings,
      selectedTypeOption,
      typeOptions,
      typeOptionVariants,
      familyPlanState,
      handleVariantChange,
      handleClose,
      calculateDiscount,
      formatMoney,
      handleOptionTypeChange,
      handleAddonSelect,
      handleRadioCheck,
      handleConfirm,
      imgUrl
    }
  },
  delimiters: ["${", "}"],
})

// select addon popup
familySubscriptionApp.component("select-addon-popup", {
  template: "#selectOilPopup",
  props: ["is_open", "index"],
  emits: ["on_addon_confirm", "on_close"],
  setup(props, ctx) {
    const selectedAddon = ref(null);
    const filterOptions = ref(familyPlanState.config.product_sets);
    const selectedFilter = ref('*');
    const filteredProductArr = ref(familyPlanState.config.products);
    const searchString = ref('');
    const isDropdownOpen = ref(false);
    const addon_dropdown = ref(null);

    onMounted(() => {
      // getting first available variant from addon
      selectedAddon.value = filteredProductArr.value.find(v => v.available);
      //filteredProductArr.value = familyPlanState.config.products.filter(p => p.set_id === selectedFilter.value && selectedFilter.value != '*');
      // if((props.index-1) < familyPlanState.config.min_plan){
      //   handleConfirm();
      // }
    });

    watch(() => props.is_open, () => {
      document.documentElement.style.overflow = "unset";
      if (props.is_open) {
        document.documentElement.style.overflow = "hidden";
      }
    });

    function handleVariantChange(e) {
      selectedAddon.value = filteredProductArr.value.find(p => p.id === e);
      isDropdownOpen.value = false;
    }

    function handeFilterChange(e) {
      selectedFilter.value = e;
      filteredProductArr.value = familyPlanState.config.products.filter(p => p.set_id === e);
      if(selectedFilter.value === '*'){
        filteredProductArr.value = familyPlanState.config.products;
      }
      if (searchString.value.length > 0) {
        filteredProductArr.value = filteredProductArr.value.filter(p => {
          const regex = new RegExp(searchString.value, 'i');
          if (regex.test(p.name)) return p;
        });
      };
      addon_dropdown.value.scrollTo({
        top: 0,
      });
    }

    function handleChecked(id) {
      return id === selectedFilter.value;
    }

    function handleClose() {
      isDropdownOpen.value = false;
      ctx.emit("on_close", null)
    }

    function handleConfirm() {
      if (selectedAddon.value) {
        ctx.emit("on_addon_confirm", {
          addon_product: selectedAddon.value
        });
        isDropdownOpen.value = false;
        resetSearchFilter();
      }
    }

    function renderNoResults() {
      return searchString.value == '' ? "No products found" : `No products found for '${searchString.value}'`;
    }

    function handleDropdownToggle() {
      isDropdownOpen.value = !isDropdownOpen.value;
    }

    function handleOpenDropdown() {
      if (!isDropdownOpen.value) {
        isDropdownOpen.value = true;
      }
    }

    function resetSearchFilter() {
      searchString.value = '';
      resetSetFilter();
    }

    function handleSearch(e) {
      //console.log(e.target.value);
      searchString.value = e.target.value;
      if (searchString.value.length > 0) {
        filteredProductArr.value = familyPlanState.config.products.filter(p => {
          const regex = new RegExp(searchString.value, 'i');
          if (regex.test(p.name)) return p;
        });
      } else {
        handeFilterChange(selectedFilter.value);
      }
    }

    function resetSetFilter() {
      selectedFilter.value = '*';
      filteredProductArr.value = familyPlanState.config.products;
      if(addon_dropdown.value){
        addon_dropdown.value.scrollTo({
          top: 0,
        });
      }
    }

    return {
      familyPlanState,
      selectedAddon,
      filterOptions,
      selectedFilter,
      filteredProductArr,
      searchString,
      isDropdownOpen,
      sectionSettings,
      addon_dropdown,
      resetSetFilter,
      calculateDiscount,
      handleOpenDropdown,
      handleDropdownToggle,
      renderNoResults,
      handeFilterChange,
      handleVariantChange,
      handleChecked,
      handleClose,
      handleConfirm,
      formatMoney,
      imgUrl,
      handleSearch
    }
  },
  delimiters: ["${", "}"],
})

// select product variant popup
familySubscriptionApp.component("select-sdc-variant-popup", {
  template: "#selectSDCVariantPopup",
  props: ["is_open", "index"],
  emits: ["on_product_confirm", "on_close"],
  setup(props, ctx) {
    const selectedVariant = ref(null);
    const selectedTypeOption = ref(null);
    const typeOptions = ref(Array.from(new Set(familyPlanState.config.parent_product_b.variants.map(p => p.title.split("/")[0].trim().toUpperCase()))));
    const typeOptionVariants = ref(typeOptions.value.reduce((acc, p) => {
      acc[p] = familyPlanState.config.parent_product_b.variants.filter(v => p === v.title.split("/")[0].trim().toUpperCase()).map(v => ({
        name: v.title.trim().toUpperCase(),
        variant_id: v.id,
        available: v.available,
        custom_swatch: v.custom_swatch,
        hide_variant: v.hide_variant,
      }));
      return acc;
    }, {}));

    onMounted(() => {
      selectedVariant.value = familyPlanState.config.parent_product_b.variants.find(v => v.available);
      const typeOption = selectedVariant.value.title.split("/")[0].trim().toUpperCase();
      if (typeOptions.value.includes(typeOption)) selectedTypeOption.value = typeOption;
      // if((props.index-1) < familyPlanState.config.min_plan){
      //   handleConfirm();
      // }
    });

    watch(() => props.is_open, () => {
      document.documentElement.style.overflow = "unset";
      if (props.is_open) {
        document.documentElement.style.overflow = "hidden";
      }
    });

    function handleClose() {
      ctx.emit("on_close", null)
    }

    function handleOptionTypeChange(type) {
      selectedTypeOption.value = type;
      let firstAvailableVariant = typeOptionVariants.value[selectedTypeOption.value].find(v => v.available);
      selectedVariant.value = familyPlanState.config.parent_product_b.variants.find(v => v.id === firstAvailableVariant.variant_id);
    }

    function handleRadioCheck(type) {
      return type === selectedTypeOption.value ? true : false;
    }

    function handleAddonSelect(variant) {
      selectedAddon.value = variant;
      isDropdownOpen.value = false;
    }

    function handleConfirm() {
      if (selectedVariant.value) {
        ctx.emit("on_product_confirm", {
          main_product: selectedVariant.value
        });
      }
    }

    function handleVariantChange(e){
      selectedVariant.value = e;
    }

    return {
      selectedVariant,
      sectionSettings,
      selectedTypeOption,
      typeOptions,
      typeOptionVariants,
      familyPlanState,
      handleVariantChange,
      handleClose,
      calculateDiscount,
      formatMoney,
      handleOptionTypeChange,
      handleAddonSelect,
      handleRadioCheck,
      handleConfirm,
      imgUrl
    }
  },
  delimiters: ["${", "}"],
})

// select addon popup
familySubscriptionApp.component("select-sdc-addon-popup", {
  template: "#selectSDCOilPopup",
  props: ["is_open", "index"],
  emits: ["on_addon_confirm", "on_close"],
  setup(props, ctx) {
    const selectedAddon = ref(null);
    const filterOptions = ref(familyPlanState.config.product_b_sets);
    const selectedFilter = ref('*');
    const filteredProductArr = ref(familyPlanState.config.products_b);
    const searchString = ref('');
    const isDropdownOpen = ref(false);
    const addon_dropdown = ref(null);

    onMounted(() => {
      // getting first available variant from addon
      selectedAddon.value = filteredProductArr.value.find(v => v.available);
      //filteredProductArr.value = familyPlanState.config.products.filter(p => p.set_id === selectedFilter.value && selectedFilter.value != '*');
      // if((props.index-1) < familyPlanState.config.min_plan){
      //   handleConfirm();
      // }
    });

    watch(() => props.is_open, () => {
      document.documentElement.style.overflow = "unset";
      if (props.is_open) {
        document.documentElement.style.overflow = "hidden";
      }
    });

    function handleVariantChange(e) {
      selectedAddon.value = filteredProductArr.value.find(p => p.id === e);
      isDropdownOpen.value = false;
    }

    function handeFilterChange(e) {
      selectedFilter.value = e;
      filteredProductArr.value = familyPlanState.config.products_b.filter(p => p.set_id === e);
      if(selectedFilter.value === '*'){
        filteredProductArr.value = familyPlanState.config.products_b;
      }
      if (searchString.value.length > 0) {
        filteredProductArr.value = filteredProductArr.value.filter(p => {
          const regex = new RegExp(searchString.value, 'i');
          if (regex.test(p.name)) return p;
        });
      };
      addon_dropdown.value.scrollTo({
        top: 0,
      });
    }

    function handleChecked(id) {
      return id === selectedFilter.value;
    }

    function handleClose() {
      isDropdownOpen.value = false;
      ctx.emit("on_close", null)
    }

    function handleConfirm() {
      if (selectedAddon.value) {
        ctx.emit("on_addon_confirm", {
          addon_product: selectedAddon.value
        });
        isDropdownOpen.value = false;
        resetSearchFilter();
      }
    }

    function renderNoResults() {
      return searchString.value == '' ? "No products found" : `No products found for '${searchString.value}'`;
    }

    function handleDropdownToggle() {
      isDropdownOpen.value = !isDropdownOpen.value;
    }

    function handleOpenDropdown() {
      if (!isDropdownOpen.value) {
        isDropdownOpen.value = true;
      }
    }

    function resetSearchFilter() {
      searchString.value = '';
      resetSetFilter();
    }

    function handleSearch(e) {
      //console.log(e.target.value);
      searchString.value = e.target.value;
      if (searchString.value.length > 0) {
        filteredProductArr.value = familyPlanState.config.products_b.filter(p => {
          const regex = new RegExp(searchString.value, 'i');
          if (regex.test(p.name)) return p;
        });
      } else {
        handeFilterChange(selectedFilter.value);
      }
    }

    function resetSetFilter() {
      selectedFilter.value = '*';
      filteredProductArr.value = familyPlanState.config.products_b;
      if(addon_dropdown.value){
        addon_dropdown.value.scrollTo({
          top: 0,
        });
      }
    }

    return {
      familyPlanState,
      selectedAddon,
      filterOptions,
      selectedFilter,
      filteredProductArr,
      searchString,
      isDropdownOpen,
      sectionSettings,
      addon_dropdown,
      resetSetFilter,
      calculateDiscount,
      handleOpenDropdown,
      handleDropdownToggle,
      renderNoResults,
      handeFilterChange,
      handleVariantChange,
      handleChecked,
      handleClose,
      handleConfirm,
      formatMoney,
      imgUrl,
      handleSearch
    }
  },
  delimiters: ["${", "}"],
})

// variant selector
familySubscriptionApp.component("product-variant-select", {
  template: "#variantSelect",
  props:["selected_product","type"],
  emits: ["on_variant_change"],
  setup(props, ctx) {
      const selectedVariant = ref(null);
      const variantContEl = ref(null);
      const productObj = ref(null);

      onBeforeMount(()=>{
        if(props.type === "A"){
          productObj.value = familyPlanState.config.parent_product;
        }

        if(props.type === "B"){
          productObj.value = familyPlanState.config.parent_product_b;
        }
      });

      onMounted(() => {
          selectedVariant.value = props.selected_product;
          if (selectedVariant.value) {
              handleVariantChecked();
              hideUnRelatedVariants();
              ctx.emit("on_variant_change", selectedVariant.value);
          }
      });

      function handleVariantChecked() {
          if (variantContEl.value) {
              selectedVariant.value.options.forEach(option_value => {
                  variantContEl.value.querySelectorAll(`input[type='radio'][value='${option_value}']`).forEach(el => {
                      el.checked = true;
                  });
              });
          }
      }

      function hideUnRelatedVariants() {
          const optionWithValues = productObj.value?.options_with_values;
          const activeOptions = [...selectedVariant.value.options];
          const productVariants = productObj.value.variants;
          const swatchGroups = variantContEl.value.querySelectorAll('.variant-block__swatch');
          variantContEl.value.querySelectorAll(`input[type='radio']`).forEach(el => el.parentElement.classList.remove('hide-option'));
          swatchGroups.forEach((grpEl,i)=>{
            let groupPosition = parseInt(grpEl.getAttribute('data-option-position'));
            if(optionWithValues.length > 1 && groupPosition > 1 && groupPosition <= optionWithValues.length){
              const primaryOptions = activeOptions.slice(0,i);
              let groupInputs = grpEl.querySelectorAll('input[type="radio"]');
              if (groupInputs) {
                groupInputs.forEach(el => {
                  let isPartOfAnyVariant = false;
                  for (let variant of productVariants) {
                    const optionCombination = [...primaryOptions, el.value];
                    const isUnRelatedVariant = optionCombination.every(o => variant.options.includes(o));
                    if (isUnRelatedVariant) {
                      isPartOfAnyVariant = true;
                      break;
                    }
                  }
                  if (!isPartOfAnyVariant) {
                    el.parentElement.classList.add('hide-option');
                  }
                });
              }
            }
          });
      }

      function handleDisableVariant(option_name) {
          return selectedVariant.value.options.includes(option_name);
      }

      function handleVariantSelect(e) {
          const selectedOptionArr = [];
          const selectedVariantInputRadio = variantContEl.value.querySelectorAll("input[type='radio']:checked");
          const productVariants = productObj.value.variants;
          let matchedVariant = null;
          selectedVariantInputRadio.forEach(el => {
              selectedOptionArr.push(el.value);
          });
          if(selectedOptionArr.length){
            for (let variant of productVariants) {
              const isSelectedVariant = selectedOptionArr.every(o => variant.options.includes(o));
              if (isSelectedVariant) {
                matchedVariant = variant;
                break;
              }
            }
            if(matchedVariant){
              selectedVariant.value = matchedVariant;
            }else{
              let partialCombination = [e.target.value];
              if(selectedOptionArr.length > 2){
                const optionsLength = productObj.value?.options_with_values.length;
                partialCombination = selectedOptionArr.slice(0,optionsLength - 1);
              }
              for (let variant of productVariants) {
                const isSelectedVariant = partialCombination.every(o => variant.options.includes(o));
                if (isSelectedVariant) {
                  matchedVariant = variant;
                  break;
                }
              }
              if (!matchedVariant) {
                matchedVariant = productVariants.find(variant => variant.options.includes(e.target.value));
              }
            }
          }
          selectedVariant.value = matchedVariant;
          handleVariantChecked();
          hideUnRelatedVariants();
          ctx.emit("on_variant_change", selectedVariant.value);
      }
    
      return {
          selectedVariant,
          variantContEl,
          familyPlanState,
          productObj,
          handleVariantChecked,
          handleVariantSelect,
          handleize,
          handleDisableVariant
      }

  },
  delimiters: ["${", "}"],
});

familySubscriptionApp.mount("#familySubscriptionApp");


function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = roundNumber(number / 100, false, precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function imgUrl(url, size) {
  if(!url) url = `https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif`;
  // remove any current image size then add the new image size
  return url
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
      return "_" + size + match;
    });
}

function handleize(str) {
  return str.toLowerCase().replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
}

function calculateDiscount(price, discountValue, discountValueType) {
  if (discountValue === 0 || discountValue === undefined || discountValue === null) {
    return null;
  }
  if (discountValueType === 'PERCENTAGE') {
    let discountedPrice = price * (discountValue / 100);
    return Number(roundNumber(price - discountedPrice, false));
  }
  if (discountValueType === 'FIXED') {
    let discountedPrice = price * (fixedDiscountToPercentage(price / 100, discountValue) / 100);
    return Number(roundNumber(price - discountedPrice, false));
  };
}

function fixedDiscountToPercentage(originalPrice, fixedDiscount) {
  let discountPercentage = (fixedDiscount / originalPrice) * 100;
  return Number(roundNumber(discountPercentage, false));
}

function roundNumber(num, savings, precision = 2) {
  if (isNaN(num)) {
    return;
  }

  let nummm = num.toFixed(3).split(".")[1].slice(2);
  if (nummm > 4 && !savings) {
    let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
    return number.toFixed(precision);
  } else if (nummm < 6 && savings) {
    let number = Math.floor((num + Number.EPSILON) * 100) / 100;
    return number.toFixed(precision);
  } else {
    let number = Math.round((num + Number.EPSILON) * 100) / 100;
    return number.toFixed(precision);
  }
}

function pluralize(count, noun, suffix = 's') {
  return `${noun}${count !== 1 ? suffix : ''}`;
}

function getAllLocalStorageData() {
  const allLocalStorageData = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    const value = localStorage.getItem(key);
    allLocalStorageData[key] = value;
  }
  return allLocalStorageData;
}

function fetchDiscountValue(basePrice, discountValue, discountType) {
  //console.log(basePrice, discountValue, discountType, "fetch discount value");
  if (discountType === 'FIXED') {
    return Number(discountValue * 100);
  }
  return basePrice * (discountValue) / 100;
}